/* Native keyboard-accessible details; no-JS fallback remains fully expanded. */
(() => {
  const breakpoint = window.matchMedia('(max-width: 749px)');
  const groups = document.querySelectorAll('footer .mcn-footer-group');
  const apply = () => groups.forEach(group => { group.open = !breakpoint.matches; });
  apply();
  breakpoint.addEventListener('change', apply);
})();
